import { Modal } from '@modusign/design-system';
import { ReactNode } from 'react';

import noop from '@libs/noop';

interface WindowModalProps {
  children: ReactNode;
  isOpen: boolean;
  maxWidth: number | string;
  testId?: string;
  onRequestClose?: () => void;
}

const defaultProps = {
  isOpen: false,
  maxWidth: 'md',
};

function WindowModal({ children, isOpen, maxWidth, testId, onRequestClose }: WindowModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      maxWidth={maxWidth}
      px={0}
      py={0}
      testId={testId}
      onClose={onRequestClose ?? noop}
      onRequestClose={onRequestClose}
    >
      {children}
    </Modal>
  );
}

WindowModal.defaultProps = defaultProps;

export default WindowModal;
